import React from "react"
import { styled } from "@mui/material/styles"
import { Button, Menu, MenuItem } from "@mui/material"

const DropdownContainer = styled('div')`
    padding: 0 15px;
`

const SFButton = styled(Button)`
    height: 40px;
    color: white;
    border-color: white;
    text-transform: none;
    font-size: 1em;
    font-weight: 300;
    &:hover {
        color: #2196F3;
        border-color: #2196F3;
    }
`

const StyledMenuItem = styled(MenuItem)`
    &:hover {
        color: #2196F3;
    }
    font-family: Lato;
    font-weight: 300;
`

export default class BrowseDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  handleOpen = (event) => {
    if (!this.state.anchorEl) {
      this.setState({ anchorEl: event.currentTarget });
    }
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <DropdownContainer>
        <SFButton
          variant="outlined"
          onClick={this.handleOpen}
          onMouseEnter={this.handleOpen}
          endIcon={<i style={{ fontSize: '1.1em' }} className="fa-solid fa-angle-down"></i>}
          aria-haspopup="true"
          aria-expanded={open}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
                e.preventDefault();
                this.handleOpen(e);
            }
          }}
        >
          Browse
        </SFButton>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          MenuListProps={{
            onMouseLeave: this.handleClose,
            autoFocus: false,
            onKeyDown: (e) => {
                if (e.key === 'Escape') {
                    this.handleClose();
                }
            }
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          elevation={3}
          disableAutoFocusItem
          disableScrollLock={true}
        >
          <StyledMenuItem component="a" href="/categories" onClick={this.handleClose} aria-label="Browse categories" className="nav-link">Categories</StyledMenuItem>
          <StyledMenuItem component="a" href="/collections" onClick={this.handleClose} aria-label="Browse collections" className="nav-link">Collections</StyledMenuItem>
          <StyledMenuItem component="a" href="/tag" onClick={this.handleClose} aria-label="Browse tags" className="nav-link">Tags</StyledMenuItem>
        </Menu>
      </DropdownContainer>
    )
  }
}
